import {timingFunctions} from 'polished';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {hoverSelector} from '../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface PaletteColorPickerItemProps {
  color: string;
  isSelected?: boolean;
  onClick?: Handler;
  size?: number;
}

/*
 * Style.
 */

const StyledWrapperButton = styled(ChromelessButton)<{$size?: number}>`
  position: relative;
  width: ${(p) => p.$size || 24}px;
  height: ${(p) => p.$size || 24}px;
`;

interface PaletteColorStyleProps {
  $isSelected?: boolean;
  $color?: string;
}
const StyledColorDiv = styled.div<PaletteColorStyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;

  background-color: ${(p) => p.$color || p.theme.greys.white};

  opacity: 0.5;

  transform: scale(0.8333);

  transition-duration: 150ms;
  transition-property: transform;
  transition-timing-function: ${timingFunctions('easeInBack')};
  display: grid;
  place-items: center;

  /* Apply the same active styles on selected or hover. */
  ${(p) => maybeAddActiveStyles(p)}
  ${hoverSelector} {
    ${addActiveStyles()}
  }
`;

function maybeAddActiveStyles(sc: PaletteColorStyleProps) {
  if (!sc.$isSelected) {
    return '';
  }

  return addActiveStyles();
}

function addActiveStyles() {
  return css`
    opacity: 1;
    transform: scale(1);
    transition-timing-function: ${timingFunctions('easeOutBack')};
  `;
}

const StyledIcon = styled(Icon)`
  color: ${(p) => p.theme.greys.white};
  margin: 4px;
`;

/*
 * Component.
 */

export const PaletteColorPickerItem: FC<PaletteColorPickerItemProps> = (props) => (
  <StyledWrapperButton onClick={props.onClick} shouldPreventMouseDown $size={props.size}>
    <StyledColorDiv $isSelected={props.isSelected} $color={props.color}>
      {maybeRenderCheckmark(props)}
    </StyledColorDiv>
  </StyledWrapperButton>
);

function maybeRenderCheckmark(props: PaletteColorPickerItemProps) {
  if (!props.isSelected) {
    return null;
  }

  return <StyledIcon name="checkmarkSelectedSmall" />;
}
